import React, { Component } from 'react';
import { MDBModal, MDBModalHeader, MDBModalBody, MDBModalFooter, toast, ToastContainer, MDBCardImage, MDBTooltip, MDBBadge, MDBCardFooter, MDBPageNav, MDBPageItem, MDBPagination, MDBInput, MDBBtn, MDBCard, MDBCardTitle, MDBCardText, MDBCardBody, MDBIcon, MDBRow, MDBCol } from 'mdbreact';
import DataLayer from '../Utilities/DataLayer';
import Formatter from '../Utilities/Formatter';
import Header from './ComponentFragments/Header';


class Challenge extends Component {
    constructor(props) {
        super(props);
        this.state = ({
            challengeData: []
        });
        this.formatter = new Formatter();

    }


    async componentWillMount() {
        this.props.loaderOn();
        //let routeParam = this.props.getRouteParam();
        var dl = new DataLayer();

        let response = await dl.Get('/challenges/getChallenge/' + this.props.match.params.challengeId);

        this.setState({
            challengeData: response.data,
            
        });
        this.props.loaderOff();
    }



    render() {
        let header = "Challenge: " + this.props.getRouteParam()
        this.TMAUser = JSON.parse(localStorage.getItem("TMAUser"));
        let shipId = this.TMAUser.data.shipId;
        return (
            <div id="top">
                <Header headerText={header}
                    subHeaderText="(Subheader Text)"
                    hideSearch='true'
                />


            </div>

        )
    }
}

export default Challenge;


